
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class TheSharer extends Vue {
  @Prop({ default: '#' }) link!: string
  @Prop({ default: '' }) title!: string

  public networks = [
    {
      network: 'facebook',
      name: 'Facebook',
      icon: 'facebook',
      color: '#1877F2',
    },
    {
      network: 'linkedin',
      name: 'LinkedIn',
      icon: 'linkedin',
      color: '#0077B5',
    },
    {
      network: 'twitter',
      name: 'Twitter',
      icon: 'twitter',
      color: '#1DA1F2',
    },
    {
      network: 'whatsapp',
      name: 'Whatsapp',
      icon: 'whatsapp',
      color: '#25D366',
    },
  ]
}
